<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle font-weight-bold pl-10">
      {{ $t(selectBoxInfo.target) }}
    </div>

    <div v-if="isEdit" class="pl-16">
      {{ target }}
    </div>
    <span v-else class="d-flex align-center">
      <div class="original-selectbox selectBoxStyle">
        <NormalCombobox
          v-model="selectClientName"
          :items="selectBoxInfo.clientNameList"
          height="32px"
        />
      </div>

      <NormalButton
        :text="$t('order.order_narrow-down-button')"
        height="32px"
        width="120px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="historySearch"
      />
      <HistorySearchDialog
        v-model="dialog.historySearch"
        :selectClientName="selectClientName"
        :target="selectBoxInfo.target"
        :comboboxList="selectBoxInfo.clientNameList"
        :tableData="history"
        @reflect="reflect"
        @change="changeHistorySearch"
      />

      <NormalTextButton
        v-if="authority.isAdmin || authority.isUser"
        :text="getButtonLabel"
        class="textButtonStyle"
        @click="dialog.registerMaster = true"
      />
      <MasterDialog
        v-model="dialog.registerMaster"
        @success="registerMasterSuccess()"
      />
    </span>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import {
  NormalButton,
  NormalTextButton,
  NormalCombobox
} from '@/components/items'

import HistorySearchDialog from '@/components/layouts/Dialogs/HistorySearchDialog'
import MasterDialog from '@/components/layouts/Dialogs/Master/Customer/MasterCustomerDialog'

export default {
  components: {
    NormalButton,
    NormalTextButton,
    NormalCombobox,
    HistorySearchDialog,
    MasterDialog
  },
  props: {
    target: { default: '' }
  },
  data: () => ({
    isEdit: false,

    selectClientName: {
      label: '',
      value: null
    },
    historySelectData: {
      selectClientName: {
        label: '',
        value: null
      },
      radioGroup: ''
    },
    selectBoxInfo: {
      target: 'sale.sale_customer',
      clientId: 'customerId',
      clientNameList: []
    },
    history: {
      headers: [
        {
          value: 'radioBtn',
          width: '55px',
          filterable: false,
          align: 'center'
        },
        {
          value: 'customerId',
          align: ' d-none'
        },
        {
          text: 'sale.sale_order-date',
          value: 'saleDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_completion-date',
          value: 'compDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_sale-number',
          value: 'transaction.controlNumber',
          width: '220px',
          filterable: false,
          align: 'center'
        },

        {
          text: 'sale.sale_author',
          value: 'user',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'common.input_currency',
          value: 'currencyId',
          width: '80px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_price',
          value: 'amount',
          width: '144px',
          filterable: false,
          align: 'end'
        }
      ],
      itemKey: 'saleId',
      items: []
    },
    dialog: {
      historySearch: false,
      registerMaster: false
    }
  }),
  async created() {
    this.isEdit = this.target ? true : false
    if (this.isEdit) return

    await this.init(false)
  },
  computed: {
    ...mapGetters('User', ['authority']),
    getButtonLabel() {
      return '＋ ' + this.$t('sale.sale_customer-registration')
    }
  },

  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),
    ...mapActions('Sale', ['getSaleListFromApi']),
    ...mapGetters('Sale', ['getSaleListFromState']),

    getHistoryListFromState() {
      return this.getSaleListFromState()
    },
    getClientListFromState() {
      return this.getCustomerListFromState()
    },

    async getClientData(isHistorySearch, selectClientNameValue) {
      return await Promise.all([
        this.getCustomersFromApi({ isHideUnusedCustomer: 1 }),
        isHistorySearch
          ? this.getSaleListFromApi({
              invalidSaleDisplay: 0,
              customerIds: selectClientNameValue
            })
          : null
      ]).then((message) => {
        return [
          this.getClientListFromState().map((ele) => {
            let label = ele.rep
            if (ele.organizationName) label += ` / ${ele.organizationName}`
            return {
              label,
              value: ele[this.selectBoxInfo.clientId]
            }
          }),
          isHistorySearch ? this.getHistoryListFromState() : []
        ]
      })
    },

    async changeHistorySearch(...args) {
      const [selectClientNameValue] = args
      await this.getSaleListFromApi({
        invalidSaleDisplay: 0,
        customerIds: selectClientNameValue
      })
      this.history.items = this.getHistoryListFromState()
    },
    async registerMasterSuccess() {
      await this.getCountryListFromApi()
      await this.init(false)
      this.dialog.registerMaster = false
    },

    async init(isHistorySearch) {
      const [clientNameList, historyList] = await this.getClientData(
        isHistorySearch,
        this.selectClientName.value
      )

      this.selectBoxInfo.clientNameList = clientNameList
      this.history.items = historyList
    },

    async historySearch() {
      if (!this.selectClientName.value) {
        alert(
          this.$t(this.selectBoxInfo.target) +
            this.$t('common.common_input-select')
        )
        return
      }
      await this.init(true)
      this.dialog.historySearch = true
    },

    reflect(...args) {
      const [selectClientName, radioGroup] = args

      const history = this.getHistoryListFromState().find(
        (ele) =>
          ele[this.selectBoxInfo.clientId] === selectClientName.value &&
          ele[this.history.itemKey] === radioGroup
      )
      const clientData = this.getClientListFromState().find(
        (ele) => ele[this.selectBoxInfo.clientId] === selectClientName.value
      )
      history.recipients = clientData ? clientData.recipients : []

      this.historySelectData = {
        selectClientName: selectClientName,
        radioGroup: radioGroup
      }
      this.selectClientName = selectClientName

      this.$emit('change', 'history', this.history.itemKey, history)
    }
  },
  watch: {
    selectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.historySelectData.selectClientName.value !== newVal.value) {
          if (!newVal.value) {
            this.$emit('change', 'select', this.selectBoxInfo.clientId, {})
            return
          }

          this.historySelectData = {
            selectClientName: { label: '', value: null },
            radioGroup: ''
          }

          const clientData = this.getClientListFromState().find(
            (ele) => ele[this.selectBoxInfo.clientId] === newVal.value
          )
          this.$emit(
            'change',
            'select',
            this.selectBoxInfo.clientId,
            clientData
          )
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;

  .titleStyle {
    font-size: 18px;
  }

  .selectBoxStyle {
    width: 340px;
    margin: 0px 16px 0px 63px !important;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }
}
</style>
